import { createContext, useContext } from "react";
import type { Program } from "@/types";

export interface WritingPreviewPrompt {
  id: string;
  title?: string | null;
  content: string;
  duration: number;
  order_index: number;
}

export interface WritingPreviewValue {
  completeWriting: () => void;
  returnPath: string;
  programOverride?: Program;
  promptsOverride?: WritingPreviewPrompt[];
  completionImageUrl?: string | null;
  previewKey: string;
  isUnsaved?: boolean;
}

/** Supplied only after the author boundary has verified the signed-in account. */
const WritingPreviewContext = createContext<WritingPreviewValue | null>(null);
export const WritingPreviewProvider = WritingPreviewContext.Provider;
export const useWritingPreview = () => useContext(WritingPreviewContext);
